
import axios from "axios";
import buildUrl from "build-url-ts";
import {
  LeadReportSummary,
  PagedResponse,
  ReportRequest,
} from "src/types/experiences/leadsAndReports";

const BASE_URL = process.env.REACT_APP_CLEVERSTORY_API_URL;
const LEAD_REPORTS = `${BASE_URL}/api/1.0/leads/reports`;
const STORYBOARD_REPORTS = `${BASE_URL}/api/1.0/storyboard/reports`;

export const leadsApi = {
  // L1 — lead summary tiles
  fetchSummary: async (storyboardId: string): Promise<LeadReportSummary> => {
    const url = buildUrl(LEAD_REPORTS, { path: `storyboard/${storyboardId}/summary` });
    const { data } = await axios.post(url ?? "");
    return data;
  },

  // L2 — single lead detail (visitor)
  fetchLeadDetail: async (profileId: string, request: ReportRequest): Promise<any> => {
    const url = buildUrl(LEAD_REPORTS, { path: `/${profileId}?page=0&limit=5` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  // L3 — first captured
  fetchFirstCaptured: async (profileId: string, request: ReportRequest): Promise<any> => {
    const url = buildUrl(LEAD_REPORTS, { path: `/${profileId}/initial` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  // L4 — latest campaign
  fetchLatestCampaign: async (profileId: string, request: ReportRequest): Promise<any> => {
    const url = buildUrl(LEAD_REPORTS, { path: `/${profileId}/latest` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  // L5 — lead journey (paged / infinite)
  fetchJourney: async (
    profileId: string,
    request: ReportRequest,
    page: number,
    limit: number,
  ): Promise<PagedResponse> => {
    const url = buildUrl(LEAD_REPORTS, { path: `/${profileId}/journey?page=${page}&limit=${limit}` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  fetchPageInteractions: async (
    profileId: string,
    request: ReportRequest,
    variant: "interactive" | "landing",
    page: number,
    limit: number,
  ): Promise<PagedResponse> => {
    const url = buildUrl(LEAD_REPORTS, {
      path: `/${profileId}/${variant}/views?page=${page}&limit=${limit}`,
    });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  // L10 — asset interactions
  fetchAssetInteractions: async (
    profileId: string,
    request: ReportRequest,
    page: number,
    limit: number,
  ): Promise<PagedResponse> => {
    const url = buildUrl(LEAD_REPORTS, { path: `/${profileId}/assets/views?page=${page}&limit=${limit}` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },

  fetchLeadsForDownload: async (
    request: ReportRequest,
    page: number,
    limit: number,
  ): Promise<PagedResponse> => {
    const url = buildUrl(STORYBOARD_REPORTS, { path: `/metrics/leads?page=${page}&limit=${limit}` });
    const { data } = await axios.post(url ?? "", request);
    return data;
  },
};
